var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWoman5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 436 436",
    style: {
      enableBackground: "new 0 0 436 436"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M267.355,258.97c0.19,0.05,0.39,0.09,0.58,0.14c10.46,2.53,20.19,6.93,28.83,12.81 c23.39,15.92,38.75,42.77,38.75,73.19V430h-47.04h-140.96h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 c8.64-5.88,18.37-10.28,28.83-12.81c0.19-0.05,0.39-0.09,0.58-0.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M147.515,306v124h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 C144.525,282.12,147.515,293.71,147.515,306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M335.515,345.11V430h-47.04V306c0-12.29,2.99-23.88,8.29-34.08 C320.155,287.84,335.515,314.69,335.515,345.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M294.475,430h-12V306c0-12.816,3.1-25.558,8.966-36.846l10.648,5.533 c-5.052,9.724-7.614,20.259-7.614,31.313V430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M315.515,416c-3.313,0-6-2.687-6-6v-73c0-3.313,2.687-6,6-6s6,2.687,6,6v73 C321.515,413.313,318.829,416,315.515,416z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M144.165,283.92c-15.21,15.89-24.56,37.45-24.56,61.19V428 h-19.12v-82.89c0-30.42,15.35-57.27,38.74-73.19C141.205,275.74,142.865,279.75,144.165,283.92z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M153.515,430h-12V306c0-11.055-2.562-21.59-7.614-31.313l10.648-5.533 c5.865,11.288,8.966,24.029,8.966,36.847V430z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M252.48,406h-68.96c-23.159,0-42-18.841-42-42h12c0,16.542,13.458,30,30,30h68.96 c16.542,0,30-13.458,30-30h12C294.48,387.159,275.639,406,252.48,406z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M349.5,436H86.73c-3.313,0-6-2.687-6-6s2.687-6,6-6H349.5c3.313,0,6,2.687,6,6 S352.813,436,349.5,436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M381.5,436h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S384.813,436,381.5,436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M65.5,436h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S68.813,436,65.5,436z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 299,
    style: {
      fill: "#333333"
    },
    width: 12,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M271.435,258.83L218.005,299l-53.26-40.04c16.09-7.01,34.26-10.96,53.5-10.96 C237.365,248,255.425,251.9,271.435,258.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A88D6"
    },
    d: "M291.475,269.77L218.005,325l-73.25-55.06c6.2-4.2,31.65-13.85,38.75-16.94l34.5,46l34.67-46.13 C259.795,255.94,285.265,265.57,291.475,269.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M343.495,430h-12v-78.69c0-25.831-11.669-50.163-32.858-68.514 c-3.332-2.884-6.872-5.593-10.517-8.051c-5.921-4.004-12.333-7.504-19.061-10.405c-15.853-6.862-32.946-10.34-50.814-10.34 c-17.977,0-35.171,3.52-51.104,10.46c-6.682,2.908-13.081,6.423-19.021,10.447c-27.405,18.61-43.125,46.459-43.125,76.402V430h-12 v-78.69c0-33.982,17.637-65.45,48.39-86.334c6.557-4.442,13.609-8.315,20.966-11.518C179.803,245.855,198.609,242,218.245,242 c19.518,0,38.215,3.81,55.573,11.324c7.409,3.194,14.483,7.057,21.018,11.476c4.035,2.721,7.959,5.725,11.655,8.923 c23.863,20.667,37.004,48.221,37.004,77.587V430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M218.005,331c-1.269,0-2.538-0.401-3.605-1.204l-74.501-56l7.212-9.591l70.894,53.289l70.875-53.282 l7.23,9.577l-1.02,0.77l-73.479,55.237C220.543,330.599,219.274,331,218.005,331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M218.005,305c-0.001,0-0.002,0-0.003,0c-1.888-0.001-3.665-0.89-4.797-2.4l-34.5-46l9.6-7.2 l29.705,39.607l29.869-39.742l9.593,7.21l-34.67,46.13C221.668,304.113,219.892,305,218.005,305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M267.36,243.97C253.26,253.46,236.28,259,218,259s-35.26-5.54-49.36-15.03 c-0.19-0.13-0.39-0.26-0.58-0.4c-23.28-15.94-38.56-42.72-38.56-73.07V148V96.5C129.5,47.623,169.123,8,218,8l0,0 c48.877,0,88.5,39.623,88.5,88.5V148v22.5c0,30.35-15.28,57.13-38.56,73.07C267.75,243.71,267.55,243.84,267.36,243.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M218,265c-18.88,0-37.107-5.551-52.71-16.052l-0.182-0.124c-0.169-0.114-0.339-0.23-0.506-0.35 c-25.737-17.657-41.102-46.8-41.102-77.974v-74C123.5,44.393,165.893,2,218,2s94.5,42.393,94.5,94.5v74 c0,31.176-15.363,60.319-41.103,77.975c-0.166,0.12-0.335,0.235-0.503,0.348l-0.138,0.094c-0.015,0.01-0.03,0.021-0.045,0.031 C255.107,259.449,236.88,265,218,265z M218,14c-45.491,0-82.5,37.009-82.5,82.5v74c0,27.241,13.439,52.706,35.95,68.12 c0.055,0.038,0.111,0.077,0.165,0.117l0.421,0.287C185.606,248.156,201.516,253,218,253s32.395-4.844,46.01-14.007l0.17-0.116 c0.07-0.047,0.143-0.094,0.211-0.145c0.052-0.038,0.105-0.076,0.159-0.112c22.51-15.414,35.949-40.879,35.949-68.12v-74 C300.5,51.009,263.491,14,218,14z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7774B"
    },
    d: "M218,218.01c-4.869,0-9.738-0.513-14.573-1.538c-3.242-0.688-5.312-3.873-4.625-7.114 c0.688-3.241,3.87-5.315,7.114-4.625c8.018,1.7,16.148,1.701,24.167,0c3.24-0.69,6.427,1.383,7.114,4.625 s-1.383,6.427-4.625,7.114C227.738,217.497,222.869,218.01,218,218.01z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M218.505,231h-1.01c-2.209,0-4-1.791-4-4s1.791-4,4-4h1.01c2.209,0,4,1.791,4,4 S220.714,231,218.505,231z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M273.474,149.414c-0.453,0-0.912-0.052-1.372-0.159c-7.917-1.852-16.286-1.852-24.203,0 c-3.225,0.754-6.454-1.249-7.209-4.476s1.249-6.454,4.476-7.209c9.705-2.271,19.964-2.271,29.669,0 c3.227,0.755,5.23,3.982,4.476,7.209C278.663,147.546,276.197,149.414,273.474,149.414z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M199.64,243.97c10.02,6.74,21.5,11.49,33.86,13.68 c-5.03,0.89-10.21,1.35-15.5,1.35c-18.28,0-35.26-5.54-49.36-15.03c-0.19-0.13-0.39-0.26-0.58-0.4 c-23.28-15.94-38.56-42.72-38.56-73.07V148c0-139,54.89-137.301,54.89-134.411l-10.384,15.807 c-15.364,23.387-15.305,53.174-0.958,76.231c2.423,3.895,10.151,17.294,10.019,20.366c-0.483,11.29-9.201,21.36-21.338,21.975 c-0.407,0.021-0.817,0.031-1.229,0.031v22.5c0,30.35,15.28,57.13,38.56,73.07C199.25,243.71,199.45,243.84,199.64,243.97z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M172.831,173.208c-1.533,0-3.065-0.583-4.237-1.751c-2.346-2.34-2.352-6.139-0.012-8.485 c6.152-6.17,15.545-7.746,23.375-3.919c2.977,1.455,4.211,5.048,2.756,8.025c-1.455,2.977-5.048,4.211-8.025,2.756 c-3.217-1.573-7.08-0.926-9.609,1.611C175.907,172.62,174.369,173.208,172.831,173.208z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M263.17,173.208c-1.539,0-3.076-0.588-4.249-1.763c-2.53-2.537-6.392-3.185-9.609-1.611 c-2.977,1.456-6.57,0.221-8.025-2.756c-1.455-2.978-0.221-6.57,2.756-8.025c7.831-3.826,17.224-2.251,23.375,3.919 c2.34,2.347,2.334,6.146-0.012,8.485C266.236,172.624,264.703,173.208,263.17,173.208z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M211.057,185c-3.313,0-6-2.687-6-6v-19.927c0-2.692-1.515-5.195-3.859-6.375 c-7.192-3.621-19.524-7.153-37.439-3.412c-3.245,0.675-6.422-1.403-7.1-4.647c-0.677-3.244,1.403-6.422,4.647-7.1 c21.306-4.448,36.389-0.041,45.289,4.441c6.454,3.249,10.462,9.799,10.462,17.093V179C217.057,182.313,214.371,185,211.057,185z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M217.995,6h-0.01c-54.17,0-99.46,41.15-104.72,95.06c-0.56,5.67-1.18,10.47-1.86,13.94 c-5.05,25.43-13.9,55.92-28.91,73c0,0,25.98,34.28,68.99,35c0,0-10-89,1-107h65.51h65.51c11,18,1,107,1,107 c43.01-0.72,68.99-35,68.99-35c-15.01-17.08-23.86-47.57-28.91-73c-0.68-3.47-1.3-8.27-1.86-13.94 C317.465,47.15,272.175,6,218.005,6H217.995z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M114.505,208.677c15.01-19.677,23.86-54.804,28.91-84.101c0.68-3.998,1.3-9.528,1.86-16.06 c4.056-47.897,31.923-87.045,69.306-102.455c-52.652,1.682-96.166,42.223-101.316,94.999c-0.56,5.67-1.18,10.47-1.86,13.94 c-5.05,25.43-13.9,55.92-28.91,73c0,0,13.852,18.25,38.051,28.396C116.587,211.842,114.505,208.677,114.505,208.677z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M289.505,229c-1.632,0-3.195-0.665-4.328-1.844c-1.154-1.202-1.756-2.829-1.663-4.492 c1.769-31.514,2.128-84.212-3.808-100.664H156.284c-5.938,16.456-5.578,69.151-3.808,100.664c0.093,1.663-0.509,3.291-1.663,4.492 c-1.153,1.202-2.753,1.882-4.421,1.843c-49.263-0.767-68.434-36.711-69.225-38.241c-1.137-2.195-0.811-4.862,0.821-6.719 c11.486-13.07,21.007-37.348,27.532-70.208c0.607-3.095,1.205-7.595,1.774-13.361c2.688-27.556,15.458-52.986,35.956-71.599 C163.755,10.253,190.296,0,217.985,0h0.02c27.689,0,54.23,10.253,74.734,28.872c20.498,18.612,33.268,44.042,35.957,71.606 c0.568,5.756,1.167,10.256,1.776,13.368c6.522,32.846,16.043,57.123,27.529,70.193c1.632,1.857,1.958,4.524,0.821,6.719 c-0.792,1.53-19.962,37.474-69.225,38.241C289.567,229,289.536,229,289.505,229z M89.845,188.499 c5.148,7.507,20.429,25.438,50.315,28.164c-1.004-22.245-2.974-87.134,7.205-103.791c1.09-1.783,3.029-2.871,5.12-2.871h131.02 c2.09,0,4.03,1.088,5.12,2.871c10.178,16.656,8.209,81.538,7.205,103.787c29.694-2.741,45.115-20.719,50.299-28.181 c-11.698-15.219-20.915-39.508-27.429-72.309c-0.686-3.499-1.339-8.378-1.946-14.519c-2.4-24.6-13.793-47.289-32.081-63.894 C266.382,21.147,242.705,12,218.005,12h-0.02c-24.7,0-48.376,9.147-66.668,25.756c-18.288,16.605-29.681,39.294-32.081,63.887 c-0.607,6.151-1.261,11.031-1.943,14.512C110.774,148.983,101.551,173.281,89.845,188.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M330.153,192.169c-1.58,0-3.13-0.64-4.24-1.75c-0.28-0.28-0.53-0.59-0.75-0.92 c-0.22-0.32-0.4-0.67-0.55-1.03s-0.27-0.74-0.34-1.12c-0.08-0.39-0.12-0.78-0.12-1.18c0-0.39,0.04-0.78,0.12-1.17 c0.07-0.38,0.19-0.76,0.34-1.12s0.33-0.71,0.55-1.04c0.22-0.33,0.47-0.63,0.75-0.91c1.11-1.12,2.66-1.75,4.24-1.75 s3.13,0.63,4.24,1.75c0.28,0.28,0.53,0.58,0.75,0.91c0.21,0.33,0.4,0.68,0.55,1.04s0.26,0.74,0.34,1.12 c0.08,0.39,0.12,0.78,0.12,1.17c0,1.59-0.64,3.13-1.76,4.25C333.273,191.529,331.733,192.169,330.153,192.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M320.785,173.001c-2.371,0-4.617-1.415-5.563-3.747c-5.636-13.901-10.409-30.597-14.187-49.624 c-0.807-4.119-1.525-9.424-2.197-16.233c-1.965-20.143-11.293-38.72-26.266-52.316c-4.311-3.913-9.044-7.366-14.069-10.263 c-2.871-1.655-3.856-5.324-2.202-8.195c1.655-2.871,5.326-3.855,8.195-2.202c5.767,3.325,11.198,7.287,16.142,11.775 c17.184,15.603,27.888,36.921,30.143,60.028c0.633,6.42,1.297,11.355,2.027,15.083c3.627,18.271,8.182,34.236,13.534,47.438 c1.245,3.071-0.235,6.57-3.306,7.815C322.299,172.86,321.536,173.001,320.785,173.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M239.51,32.687c-0.489,0-0.986-0.06-1.482-0.186c-6.531-1.659-13.274-2.5-20.042-2.5 c-3.313,0-6-2.687-6-6s2.687-6,6-6c7.764,0,15.501,0.965,22.998,2.87c3.211,0.816,5.154,4.081,4.338,7.293 C244.631,30.878,242.189,32.687,239.51,32.687z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F95428"
    },
    points: "218,325 218,351 186.5,377 193.5,334  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F95428"
    },
    points: "218,325 218,351 249.5,377 242.5,334  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M186.499,383c-1.025,0-2.056-0.262-2.986-0.796c-2.167-1.244-3.337-3.701-2.935-6.167l7-43 c0.348-2.138,1.82-3.921,3.853-4.668l24.5-9c1.839-0.677,3.896-0.411,5.503,0.712c1.608,1.122,2.566,2.959,2.566,4.92v26 c0,1.791-0.8,3.487-2.181,4.627l-31.5,26C189.219,382.536,187.863,383,186.499,383z M198.859,338.423l-3.873,23.793L212,348.172 v-14.576L198.859,338.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M249.501,383c-1.364,0-2.72-0.464-3.82-1.373l-31.5-26C212.8,354.487,212,352.791,212,351v-26 c0-1.961,0.958-3.798,2.566-4.92c1.608-1.123,3.664-1.389,5.503-0.712l24.5,9c2.033,0.747,3.505,2.53,3.853,4.668l7,43 c0.402,2.466-0.768,4.923-2.935,6.167C251.557,382.737,250.526,383,249.501,383z M224,348.172l17.014,14.044l-3.873-23.793 L224,333.596V348.172z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 212.005,
    y: 299,
    style: {
      fill: "#333333"
    },
    width: 12,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M269.505,367c-3.313,0-6-2.687-6-6v-36c0-3.313,2.687-6,6-6s6,2.687,6,6v36 C275.505,364.313,272.819,367,269.505,367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.505,206c-3.313,0-6-2.687-6-6v-16c0-3.313,2.687-6,6-6s6,2.687,6,6v16 C279.505,203.313,276.819,206,273.505,206z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman5);
export default __webpack_public_path__ + "static/media/woman5.0df5fdf2c715d3c67abd6d5408456c61.svg";
export { ForwardRef as ReactComponent };